import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createTrainingLog = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createTrainingLog, { input: object })
    );
    return response.data.createTrainingLog;
  } catch (error) {
    console.error("Error creating TrainingLog:", error);
    throw error;
  }
};

const updateTrainingLog = async (id, args) => {
  try {
    // First, fetch the current version of the TrainingLog
    const getTrainingLogResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getTrainingLog, { id })
    );
    const currentTrainingLog = getTrainingLogResponse.data.getTrainingLog;

    // Prepare the update input
    const updateInput = { id, _version: currentTrainingLog._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateTrainingLog, { input: updateInput })
    );
    return response.data.updateTrainingLog;
  } catch (error) {
    console.error("Error updating TrainingLog:", error);
    throw error;
  }
};

const deleteTrainingLog = async (id) => {
  try {
    // First, fetch the current version of the TrainingLog
    const getTrainingLogResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getTrainingLog, { id })
    );
    const currentTrainingLog = getTrainingLogResponse.data.getTrainingLog;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteTrainingLog, {
        input: { id, _version: currentTrainingLog._version },
      })
    );
    return response.data.deleteTrainingLog;
  } catch (error) {
    console.error("Error deleting TrainingLog:", error);
    throw error;
  }
};

const getTrainingLogsByWorkspaceID = async (workspaceID, nextToken) => {
  return makeGraphQLRequest({
    query: queries.trainingLogsByWorkspace,
    variables: {
      workspaceID,
      nextToken,
    },
  });
};

export default {
  createTrainingLog,
  updateTrainingLog,
  deleteTrainingLog,
  getTrainingLogsByWorkspaceID,
};
